import htmx from 'htmx.org';

let configured = false;

export function installHtmxSendAbortFilter(): void {
  const globalWindow = window as Window & { __htmxSendAbortFilterInstalled?: boolean };
  if (globalWindow.__htmxSendAbortFilterInstalled) {
    return;
  }
  globalWindow.__htmxSendAbortFilterInstalled = true;

  // HTMX logs sendAbort via console.error before the event is cancelable.
  const originalError = console.error.bind(console);
  console.error = (...args: unknown[]) => {
    if (args.length === 1 && args[0] === 'htmx:sendAbort') {
      return;
    }
    originalError(...args);
  };
}

export function configureHtmx(options?: {
  onAfterSettle?: (target: Element) => void;
}): void {
  if (configured) {
    return;
  }
  configured = true;

  installHtmxSendAbortFilter();

  if (typeof window !== 'undefined') {
    window.htmx = htmx;
  }

  const body = document.body;
  if (!body) {
    return;
  }

  body.addEventListener('htmx:configRequest', event => {
    const customEvent = event as CustomEvent<{ headers?: Record<string, string> }>;
    const csrfInput = document.querySelector('[name=csrfmiddlewaretoken]');
    if (csrfInput instanceof HTMLInputElement && csrfInput.value) {
      customEvent.detail.headers = customEvent.detail.headers ?? {};
      customEvent.detail.headers['X-CSRFToken'] = csrfInput.value;
    }
  });

  body.addEventListener('htmx:afterSettle', event => {
    const customEvent = event as CustomEvent<{ target?: EventTarget | null }>;
    const target = customEvent.detail?.target;
    if (target instanceof Element) {
      options?.onAfterSettle?.(target);
      const alpine = (window as Window & { Alpine?: { initTree: (el: Element) => void } })
        .Alpine;
      alpine?.initTree(target);
    }
  });
}

export { htmx };
